import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { OLD_PRICE, PRICE } from '../data/wf';
const recap = ['6 tomów', '5 bonusów', '12 gotowych lekcji', 'Klasy 1–8'];
const reassurances = ['Natychmiastowy dostęp do pobrania', 'PDF-y do wydruku', '7 dni gwarancji satysfakcji'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="15fghwkon130x">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="1jbadk20ehvw3" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1t2yb8knjw960">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1t252je5179l8">
          Twoje lekcje WF mogą być <em className="text-red-700" data-id="element-118" data-mp="223mimwifvb9x">gotowe już dziś.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="223wbcruvbwjb">
          Zamiast szukać po dziesiątkach stron, samodzielnie wymyślać każde ćwiczenie i spędzać
          niedzielne wieczory na planowaniu, masz uporządkowany pakiet do WF na cały rok szkolny. Więcej
          czasu na to, co naprawdę ważne:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="x38yfqdjfs3s">
          Twoi uczniowie. Twoje lekcje. Twoje życie poza szkołą.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="120ip19cny9t7">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="1b2ru3jp5xaz7">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-2xl leading-none text-slate-900/50" data-id="element-123" data-mp="1b1gqpkzmq58m">
          <span className="sr-only" data-id="element-124" data-mp="1furz3qk3au2n">Cena regularna: </span>
          <s data-id="element-125" data-mp="1ktwckte1rdys">{OLD_PRICE}</s>
        </p>
        <p className="mt-3 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-126" data-mp="1kstgm71valc0">
          <span className="sr-only" data-id="element-127" data-mp="1puahw3o9k9t4">Cena teraz: </span>
          {PRICE}
        </p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-128" data-mp="1tukonijvr491">Jednorazowa płatność – bez subskrypcji.</p>

        <div className="mt-8 flex justify-center" data-id="element-129" data-mp="3qvgpnwhf0bax">
          <CtaButton className="w-full sm:w-auto" data-id="element-130" data-mp="3lvuedsl5d54r" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-131" data-mp="3lxf6lbjzobzg">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-132" data-mp="3uwitkqma1bj8">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-133" data-mp="3uuzdb00mf0hg" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}